/**
 * External dependencies
 */
import { omit } from 'lodash';
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { INITIALIZE_SYNC_RESOURCE } from 'state/action-types';

import { createReducer } from 'state/utils';

export const resourceId = createReducer(null, {
    [INITIALIZE_SYNC_RESOURCE]: (state, { payload }) => payload.resourceId,
});

export default combineReducers({
    resourceId,
});
